import { render, staticRenderFns } from "./RegisterInternet.vue?vue&type=template&id=0ae27c84"
import script from "./RegisterInternet.vue?vue&type=script&lang=js"
export * from "./RegisterInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports